import React, { Component } from 'react';
import './scss/style.scss';

const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
);

const TheLayout = React.lazy(() => import('./components/TheLayout'));

class App extends Component {
    render() {
        return (
            <React.Suspense fallback={loading}>
                <TheLayout />
            </React.Suspense>
        );
    }
}

export default App;
